export function useOlderVisitsSearch(visits) {
  function filterByParams(params) {
    let results = Array.isArray(visits.value) ? visits.value : visits

    if (params.identifier) {
      const keyword = params.identifier.trim().toLowerCase()
      results = results.filter(
        (v) =>
          (v.encounterId || '').toLowerCase().includes(keyword) ||
          v.conditions.some((c) => c.name.toLowerCase().includes(keyword))
      )
    }

    if (params.startDate) {
      results = results.filter((v) => new Date(v.createdAt || v.date) >= params.startDate)
    }

    if (params.endDate) {
      results = results.filter((v) => new Date(v.createdAt || v.date) <= params.endDate)
    }

    return results
  }

  return { filterByParams }
}
